import { Box } from '@mui/material';
import React from 'react';
import { TrusteeCorporate } from '../../models/InvestmentEntity';
import { StyledInput } from '../styles/StyledInputs';
import { StyledTypography } from '../styles/styles';

interface TrusteeCorporateSectionProps {
  trusteeCorporate: TrusteeCorporate | null;
  trusteeCorporateError?: string;
  allErrors: Record<string, string | undefined>;
  onUpdate: (field: keyof TrusteeCorporate, value: string) => void;
}

export const TrusteeCorporateSection: React.FC<TrusteeCorporateSectionProps> = ({
  trusteeCorporate,
  trusteeCorporateError,
  allErrors,
  onUpdate,
}) => (
  <Box sx={{ mt: 2 }}>
    <StyledTypography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
      Corporate Trustee Details
    </StyledTypography>

    {trusteeCorporateError && (
      <StyledTypography variant="caption" color="error" sx={{ mb: 2, display: 'block' }}>
        {trusteeCorporateError}
      </StyledTypography>
    )}

    <Box sx={{ display: 'flex', gap: 2 }}>
      <StyledInput
        label="Company Name"
        value={trusteeCorporate?.companyName || ''}
        onChange={(e) => onUpdate('companyName', e.target.value)}
        error={!!allErrors['trusteeCorporate.companyName']}
        helperText={allErrors['trusteeCorporate.companyName']}
        required
        fullWidth
      />
      <StyledInput
        label="ACN"
        value={trusteeCorporate?.acn || ''}
        onChange={(e) => onUpdate('acn', e.target.value)}
        error={!!allErrors['trusteeCorporate.acn']}
        helperText={allErrors['trusteeCorporate.acn']}
        required
        fullWidth
      />
    </Box>
  </Box>
);
